import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { apiSciScoreClient } from '@utils/api/base';
import { AppThunk } from '../store';
import { OrderL } from '../type';

export interface Orders {
  errors: Array<string>;
  limit?: number;
  size?: number;
  start_after?: number;
  continues: boolean;
  data: OrderL[];
}

let initialState: Orders = {
  errors: [],
  continues: false,
  data: [],
};

const orderSlice = createSlice({
  name: 'orders',
  initialState: initialState,
  reducers: {
    addOne: (state, { payload }: PayloadAction<OrderL>) => {
      state.data.push(payload);
    },
    // addMany: (state, action: PayloadAction<Compound2[]>) => {
    //   state.data.push(...action.payload);
    // },
    replace: (state, action: PayloadAction<OrderL[]>) => {
      state.data = action.payload;
    },
    // update: (state, { payload }: PayloadAction<SubmissionL>) => {
    //   const cmpToUpdate = state.data.find((cmp) => cmp._id === payload._id);
    //   if (cmpToUpdate) {
    //     const { path, value } = payload;
    //     _.set(cmpToUpdate, path, value);
    //   }
    // },
  },
});

export const { addOne, replace } = orderSlice.actions;

export default orderSlice.reducer;

export const getOrders =
  (page: number = 0): AppThunk =>
  async (dispatch) => {
    try {
      const { data } = await apiSciScoreClient.get('/order/');
      console.log(data);
      dispatch(replace(data.data));
    } catch (err) {
      console.error('getOrders Failed: ', err);
    }
  };

export const checkCredits = async (dispatch) => {
  try {
    const { data } = await apiSciScoreClient.get('/order/credits');
    console.log(data);
    dispatch(replace(data.data));
  } catch (err) {
    console.error('checkCredits Failed: ', err);
  }
};
